import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import {
    EnterFrom,
    EnterFade
} from 'tradera/components/transitions/transitions';
import { Overlay } from 'tradera/components/scrollable-modal/overlay';
import { RemoveScroll } from 'react-remove-scroll';
import styles from './bottom-sheet.module.scss';
import classnames from 'classnames';

type BottomSheetProps = React.PropsWithChildren<{
    show: boolean;
    onDismiss?: () => void;
    maxHeight?: string;
    inlineStyle?: React.CSSProperties;
    className?: string;
}>;

export const BottomSheet = ({
    children,
    show,
    onDismiss,
    className,
    inlineStyle = {},
    maxHeight = '100%'
}: BottomSheetProps) => (
    <TransitionGroup component={null} mountOnEnter>
        {show && (
            <EnterFade in={show}>
                <Overlay closeModalCallback={onDismiss} />
            </EnterFade>
        )}
        {show && (
            <EnterFrom from={'bottom'} in={show}>
                <RemoveScroll forwardProps>
                    <div className={styles.sheetContainer}>
                        <div
                            className={classnames(
                                'bg-white',
                                styles.bottomSheet,
                                className
                            )}
                            style={{
                                maxHeight: `min(${maxHeight}, 100%)`,
                                ...inlineStyle
                            }}>
                            {children}
                        </div>
                    </div>
                </RemoveScroll>
            </EnterFrom>
        )}
    </TransitionGroup>
);
